import type { IconNode } from '../types';

/**
 * @name tuxedo
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgM3YybDQtMnYyWiIgLz4KICA8cGF0aCBkPSJNMTggM2gxYTIgMiAwIDAgMSAxLjcgM0E1MjcwLjUgNTI3MC41IDAgMCAwIDEyIDIxUzYuOCAxMiAzLjMgNkEyIDIgMCAwIDEgNSAzaDEiIC8+CiAgPHBhdGggZD0iTTEyIDloLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAxM2guMDEiIC8+CiAgPHBhdGggZD0iTTIxIDV2MTRhMiAyIDAgMCAxLTIgMkg1YTIgMiAwIDAgMS0yLTJWNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/tuxedo
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const tuxedo: IconNode = [
  ['path', { d: 'M10 3v2l4-2v2Z', key: '17xmku' }],
  [
    'path',
    {
      d: 'M18 3h1a2 2 0 0 1 1.7 3A5270.5 5270.5 0 0 0 12 21S6.8 12 3.3 6A2 2 0 0 1 5 3h1',
      key: '1gxhoo',
    },
  ],
  ['path', { d: 'M12 9h.01', key: '1cvtyr' }],
  ['path', { d: 'M12 13h.01', key: 'y0uutt' }],
  ['path', { d: 'M21 5v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5', key: '1exknv' }],
];

export default tuxedo;
